<template>
  <div class="navbar-subnav">
    <div class="container-fluid">
      <ul class="nav nav-subnav" ref="ul" :class="{'has-underline': has_active}">
        <li v-if="heading" class="nav-subnav-heading d-flex align-items-center pr-3">
          <h1>{{ heading }}</h1>
        </li>
        <router-link
          v-if="showLinks && (!link.permission || $root.checkPermission(link.permission)) && (!link.adminOnly || $root.isAdmin())"
          v-for="link in links"
          :key="link.to"
          :to="link.to"
          :exact="link.exact || false"
          tag="li"
          class="nav-item pr-3"
        >
          <a class="nav-link px-0">{{ link.text }}</a>
        </router-link>
        <li v-if="!showLinks" class="nav-item pr-3" style="opacity: 0;">
          <a class="nav-link px-0">&nbsp;</a>
        </li>
      </ul>
      <div class="nav-subnav-active-underline" v-if="has_active" :style="underline_style"></div>
    </div>
  </div>
</template>

<script>
  // import $ from 'jquery'

  export default {
    name: 'subnav',
    props: {
      links: {type: Array},
      heading: {type: String},
      showLinks: {type: Boolean, default: true},
    },
    data () {
      return {
        slide: false,
        has_active: false,
        active: {
          left: 0,
          width: 0,
        },
      }
    },
    // watch: {
    //   $route () {
    //     this.updatePosition()
    //   },
    // },
    // methods: {
    //   updatePosition () {
    //     this.$nextTick(() => {
    //       let $active = $(this.$refs.ul).find('.active a')
    //       if ($active.length) {
    //         this.active.width = $active.width()
    //         this.active.left = $active.position().left
    //         this.has_active = true
    //       } else {
    //         this.has_active = false
    //       }
    //     })
    //   },
    // },
    // computed: {
    // underline_style () {
    //   return {
    //     transform: `translateX(${this.active.left}px) translateZ(0px)`,
    //     width: `${this.active.width}px`,
    //   }
    // },
    // },
    // mounted () {
    //   this.updatePosition()
    // },
  }
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/subnav.vue